import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  ElementRef,
  inject,
  input,
  output,
  viewChild,
} from '@angular/core';

import { ConfigService } from '@fcom/core/services/config/config.service';
import { Airport } from '@fcom/common/interfaces/booking/multi-city-state.interface';
import { FinnairThemeService } from '@fcom/common/services/theme/finnair-theme.service';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';

/**
 * @Unstable
 * Warning! This component is in active development and is not production ready.
 *
 * Documentation can be found in `storybook/stories/flights/unified-flight-object.stories.mdx`
 */
@Component({
  selector: 'fcom-ufo',
  templateUrl: 'unified-flight-object.component.html',
  styleUrls: ['./unified-flight-object.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UnifiedFlightObjectComponent {
  private themeService = inject(FinnairThemeService);

  readonly isLegacy = computed(() => this.themeService.siteTheme() === FinnairTheme.LEGACY);

  departure = input.required<Airport>();
  arrival = input.required<Airport>();
  tails = input<string[]>([]);
  duration = input('');
  airlines = input<string[]>([]);
  stops = input(0);
  showViewDetails = input(true);
  isByBusOnly = input(false);
  isByTrainOnly = input(false);
  /** When set to true, moves focus to the view details button. */
  focusOnViewDetails = input<boolean>(false);
  flightNumbers = input('');
  viewDetailsBtnKey = input('manageMyBooking.widget.viewFullOrder');

  viewDetails = output<MouseEvent>();

  readonly viewDetailsBtn = viewChild<ElementRef>('viewDetailsBtn');

  showFlightNumber = false;

  constructor() {
    const configService = inject(ConfigService);
    this.showFlightNumber = configService.cfg.enableShowFlightNumbers;

    effect(() => {
      if (this.showViewDetails() && this.focusOnViewDetails()) {
        const btn = this.viewDetailsBtn();
        btn?.nativeElement.focus();
      }
    });
  }
}
